<template>
    <blank-layout>


        <div class="flex flex-grow justify-center items-center">


            <div class="w-full max-w-7xl px-4 sm:px-6 lg:px-8 flex justify-center">

                <div
                    class="relative flex justify-center items-center w-full max-w-7xl px-4 sm:px-6 lg:px-8 h-full min-h-[500px]">
                    <transition :name="transitionName" mode="out-in">
                        <div :key="step" class="w-full">
                            <div v-if="step == 1" class="step1 w-full max-w-6xl flex flex-col">

                                <div class="flex items-center gap-x-3">

                                    <div
                                        class="size-16 shrink-0 rounded-2xl overflow-hidden flex items-center justify-center bg-birdie-blue">
                                        <img src="/img/birdie-logo-white.svg" class="h-full w-full" />
                                    </div>

                                    <div v-if="integration.name == 'intercom'"
                                        class="size-16 shrink-0 rounded-2xl overflow-hidden flex items-center justify-center"
                                        style="background-color:#000;">
                                        <img src="/img/intercom_white.svg" class="size-12" />
                                    </div>

                                    <div v-else-if="integration.name == 'zendesk'"
                                        class="size-16 shrink-0 rounded-2xl overflow-hidden flex items-center justify-center"
                                        style="background-color:#03363D;">
                                        <img src="/img/zendesk_white.svg" class="size-8" />
                                    </div>

                                    <div v-else-if="integration.name == 'hubspot'"
                                        class="size-16 shrink-0 rounded-2xl overflow-hidden flex items-center justify-center"
                                        style="background-color:#ED6744;">
                                        <img src="/img/hubspot-logo.svg" class="size-10" />
                                    </div>

                                    <div v-else-if="integration.name == 'freshdesk'"
                                        class="size-16 shrink-0 rounded-2xl overflow-hidden flex items-center justify-center"
                                        style="background-color:#25c16f;">
                                        <img src="/img/freshdesk_white.svg" class="size-9" />
                                    </div>

                                    <div v-else-if="integration.name == 'freshchat'"
                                        class="size-16 shrink-0 rounded-2xl overflow-hidden flex items-center justify-center"
                                        style="background-color:#20A849;">
                                        <img src="/img/freshchat_white.svg" class="size-9" />
                                    </div>

                                    <h1
                                        class="ml-5 md:ml-2 lg:ml-5 text-3xl md:text-4xl lg:text-5xl font-bold text-gray-900">
                                        Congrats, Birdie is ready to use!</h1>
                                </div>

                                <h2 class="text-3xl lg:text-4xl text-gray-900 mt-8">Invite your agents</h2>

                                <div class="mt-6 max-w-2xl w-full flex flex-col gap-y-4">

                                    <div class="flex justify-between items-center mt-4 ">

                                        <input type="text" v-model="search" placeholder="search…"
                                            class="text-left w-full inline py-2 px-3 border-0 border-gray-300  bg-white  text-birdie-blue  rounded-lg focus:ring-0 flex-grow text-sm" />


                                        <div class="flex flex-row justify-between items-center bg-transparent rounded-lg px-5 py-2 flex-shrink-0 cursor-pointer"
                                            @click="toggle_all">
                                            <div class="flex justify-end items-center flex-grow gap-x-2"
                                                v-tippy="{ content: selectable == 0 ? 'All agents already in Birdie' : null, placement: 'top' }">

                                                <span class="text-sm/6 font-semibold text-gray-900">Select all</span>
                                                <span class="text-sm/6 text-gray-500 w-20">({{
                                                    num_selected }}/{{ agents.length }})</span>

                                                <input type="checkbox" :checked="all_checked"
                                                    :class="[selectable == 0 ? 'pointer-events-none' : '', 'col-start-1 row-start-1 appearance-none rounded border border-gray-300 bg-white  disabled:bg-gray-100 disabled:checked:bg-gray-100 forced-colors:appearance-auto focus:ring-0']" />
                                            </div>

                                        </div>
                                    </div>

                                    <div
                                        class="h-16 h-24 h-36 h-48 h-64 max-h-16 max-h-24 max-h-36 max-h-48 max-h-64 hidden">
                                    </div>
                                    <div
                                        :class="'max-h-' + list_height + ' h-'+list_height + ' overflow-hidden overflow-y-auto'">
                                        <ul v-if="agents_searched.length > 0" role="list" class="flex flex-col gap-y-2">

                                            <li v-for="agent in agents_searched" :key="agent.email"
                                                @click="toggle_agent(agent)"
                                                :class="[agent.selectable ? 'cursor-pointer hover:bg-gray-300' : 'cursor-default', 'flex justify-between items-center gap-x-2 py-2 bg-gray-200 rounded-lg px-5 group']">

                                                <div class="flex gap-x-4 flex-shrink-0 flex-grow items-center">

                                                    <span
                                                        :class="[agent.selectable ? 'bg-white' : 'bg-transparent text-gray-400', 'size-6 flex items-center justify-center rounded-full']">
                                                        <UserIcon v-if="agent.selectable" class="w-5 h-5" />
                                                        <CheckIcon v-else class="size-4" />
                                                    </span>

                                                    <div
                                                        :class="[agent.selectable ? 'text-gray-900' : ' text-gray-400', 'text-sm/6 font-semibold']">
                                                        {{ agent.name }}
                                                    </div>

                                                    <div
                                                        :class="[agent.selectable ? 'text-gray-500' : 'text-gray-400', 'text-sm/6 ']">
                                                        {{ agent.email }}
                                                    </div>
                                                </div>

                                                <div v-if="!agent.selectable"
                                                    class="hidden flex-shrink-0 sm:flex sm:flex-col sm:items-end text-gray-500 text-sm opacity-0 group-hover:opacity-100 transition-opacity duration-300 translate-x-6">
                                                    Already a Birdie User
                                                </div>

                                                <div v-if="false"
                                                    class="hidden flex-shrink-0 sm:flex sm:flex-col sm:items-end">
                                                    <p v-if="agent.type != ''" class="text-sm/6 text-gray-900">{{
                                                        agent.type
                                                        }}
                                                    </p>
                                                </div>

                                                <input type="checkbox" :checked="agent.checked"
                                                    :class="[!agent.selectable ? 'group-hover:opacity-0 transition-opacity duration-300 opacity-0' : '', 'col-start-1 row-start-1 appearance-none rounded border border-gray-300 bg-white  disabled:bg-gray-100 disabled:checked:bg-gray-100 forced-colors:appearance-auto focus:ring-0']"
                                                    :disabled="!agent.selectable" />
                                            </li>
                                        </ul>
                                        <div v-else class="flex flex-col justify-start items-start h-full pl-1">

                                            <p class="text-sm/6 text-gray-500" v-if="agents.length == 0">No agents
                                                found
                                            </p>
                                            <p class="text-sm/6 text-gray-500" v-if="agents.length > 0 && search != ''">
                                                No
                                                matching agents found</p>
                                        </div>

                                    </div>

                                    <div class="flex flex-row justify-start items-center gap-x-6 flex-grow">
                                        <div class="flex flex-shrink items-center -ml-2">
                                            <copy-link :copy-text="invite_link" copy-label="Copy invite link"
                                                copySuccess="Copied! You can now send the invite link to your teammates."
                                                timeout="4" />
                                        </div>

                                    </div>

                                    <div class="flex flex-row justify-start items-center gap-x-6 flex-grow ">

                                        <button
                                            class="bg-gray-900 text-white py-2 px-10 rounded-lg flex flex-row justify-center items-center gap-x-2 hover:bg-gray-800"
                                            @click="save_and_continue()">
                                            <span>Continue</span>
                                        </button>

                                        <button v-if="false"
                                            class="bg-transparent text-gray-400 py-2 px-2 rounded-lg flex flex-row justify-center items-center gap-x-2 hover:text-gray-500 text-sm"
                                            @click="skip()">
                                            <span>Skip</span>
                                        </button>

                                    </div>


                                </div>

                            </div>

                            <div v-if="step == 2" class="step2 flex flex-row justify-center items-center">
                                <div class="min-w-170 overflow-hidden rounded-xl bg-white shadow-xl">
                                    <div
                                        class="px-4 py-5 sm:px-6 pt-20 flex flex-col justify-center items-center relative">

                                        <div v-if="skipped"
                                            class="absolute top-2 left-2 flex items-center justify-start text-gray-600 text-sm cursor-pointer hover:text-gray-700 gap-x-1 group"
                                            @click="step = 1">
                                            <ArrowLeftIcon
                                                class="size-4 flex items-center justify-center group-hover:-translate-x-0.5 transition-transform duration-300">
                                            </ArrowLeftIcon> back
                                        </div>

                                        <div class="flex justify-center items-center gap-x-0">

                                            <div
                                                class="size-16 scale-75 shrink-0 rounded-2xl overflow-hidden flex items-center justify-center bg-birdie-blue">
                                                <img src="/img/birdie-logo-white.svg" class="h-full w-full" />
                                            </div>

                                            <div v-if="integration.name == 'intercom'"
                                                class="size-16 scale-75 shrink-0 rounded-2xl overflow-hidden flex items-center justify-center"
                                                style="background-color:#000;">
                                                <img src="/img/intercom_white.svg" class="size-12" />
                                            </div>

                                            <div v-else-if="integration.name == 'zendesk'"
                                                class="size-16 scale-75 shrink-0 rounded-2xl overflow-hidden flex items-center justify-center"
                                                style="background-color:#03363D;">
                                                <img src="/img/zendesk_white.svg" class="size-8" />
                                            </div>

                                            <div v-else-if="integration.name == 'hubspot'"
                                                class="size-16 scale-75 shrink-0 rounded-2xl overflow-hidden flex items-center justify-center"
                                                style="background-color:#ED6744;">
                                                <img src="/img/hubspot-logo.svg" class="size-10" />
                                            </div>

                                            <div v-else-if="integration.name == 'freshdesk'"
                                                class="size-16 scale-75 shrink-0 rounded-2xl overflow-hidden flex items-center justify-center "
                                                style="background-color:#25c16f;">
                                                <img src="/img/freshdesk_white.svg" class="size-9" />
                                            </div>

                                            <div v-else-if="integration.name == 'freshchat'"
                                                class="size-16 scale-75 shrink-0 rounded-2xl overflow-hidden flex items-center justify-center"
                                                style="background-color:#20A849;">
                                                <img src="/img/freshchat_white.svg" class="size-9" />
                                            </div>
                                        </div>
                                        <h1 class=" text-2xl font-bold text-gray-900 mt-2">
                                            All set!</h1>
                                    </div>

                                    <div v-if="integration.name == 'hubspot'"
                                        class="px-10 sm:px-20 py-5 sm:py-2 text-center text-gray-600 min-h-44 grid grid-cols-1 justify-center items-center gap-y-3 mb-5 ">

                                        <a :href="integration.link_helpdesk" target="_blank"
                                            class="flex flex-col items-start justify-start mt-10 rounded-md bg-indigo-100 p-6 gap-y-0 group hover:bg-indigo-200 transition-colors duration-300">
                                            <span class="font-bold">Using HubSpot Help Desk?</span>
                                            <div class="flex items-center gap-x-2">
                                                <span>Click here to add Birdie to your Help Desk Sidebar</span>
                                                <ArrowRightIcon
                                                    class="size-5 group-hover:translate-x-1 transition-transform duration-300" />
                                            </div>
                                        </a>

                                        <a :href="integration.link_crm" target="_blank"
                                            class="flex flex-col items-start justify-start rounded-md bg-indigo-100 p-6 gap-y-0 group hover:bg-indigo-200 transition-colors duration-300">
                                            <span class="font-bold">Using HubSpot CRM?</span>
                                            <div class="flex items-center gap-x-2">
                                                <span>Click here to add Birdie to your CRM Ticket Sidebar</span>
                                                <ArrowRightIcon
                                                    class="size-5 group-hover:translate-x-1 transition-transform duration-300" />
                                            </div>
                                        </a>
                                    </div>

                                    <div v-else
                                        class="px-4 py-5 sm:p-6 text-center text-gray-600 min-h-44 flex flex-col justify-start items-center">
                                        Refresh your {{ integration.label }} tab to start using Birdie.
                                    </div>

                                    <div class="px-4 py-4 sm:px-6 text-center text-gray-400 text-sm">
                                        You can now close this tab.
                                    </div>
                                </div>
                            </div>

                        </div>
                    </transition>
                </div>

            </div>

        </div>

    </blank-layout>
</template>

<script>

import BlankLayout from "@/Layouts/BlankLayout"
import { ArrowRightIcon, UserGroupIcon, UserIcon, LinkIcon, ArrowLeftIcon, CheckIcon } from '@heroicons/vue/20/solid'
import CopyLink from '@/Components/UI/CopyLink.vue'


export default {
    props: [
        'integration', 'the_agents', 'invite_link' // success, error
    ],


    components: {
        BlankLayout, ArrowRightIcon, UserGroupIcon, UserIcon, CopyLink, LinkIcon, ArrowLeftIcon, CheckIcon
    },

    data() {
        return {
            domain: this.$page.props.app_url.split('.').slice(-2).join('.'),
            search: '',
            agents: this.the_agents,
            step: 1,
            transitionName: 'slide-left',
            skipped: false,
            selectable: 0,
            list_height: 64,
            intercom_success: 'https://app.intercom.com/appstore/redirect?install_success=true'
        }
    },
    created() {
        for (let i = 0; i < this.agents.length; i++) {
            if (this.agents[i].selectable) {
                this.selectable++;
                this.agents[i].checked = true;
            }
        }
        if (this.agents.length <= 1) {
            this.list_height = 16;
        } else if (this.agents.length == 2) {
            this.list_height = 24;
        } else if (this.agents.length == 3) {
            this.list_height = 36;
        } else if (this.agents.length == 4) {
            this.list_height = 48;
        }
    },
    beforeUnmount() {

    },
    mounted() {
        window.intercomSettings.hide_default_launcher = false;
    },
    computed: {
        num_selected() {
            return this.agents.filter(agent => agent.checked).length;
        },
        all_checked() {
            return this.agents.every(agent => agent.checked || !agent.selectable) && this.selectable > 0;
        },
        agents_searched() {
            if (this.search == '') {
                return this.agents
            }
            return this.agents.filter(agent => {
                return agent.name.toLowerCase().includes(this.search.toLowerCase()) || agent.email.toLowerCase().includes(this.search.toLowerCase())
            })
        },
    },
    methods: {
        toggle_agent(agent) {
            if (agent.selectable) {
                agent.checked = !agent.checked;
            }
        },
        toggle_all() {
            if (this.all_checked) {
                for (let i = 0; i < this.agents.length; i++) {
                    this.agents[i].checked = false;
                }
            } else {
                for (let i = 0; i < this.agents.length; i++) {
                    if (this.agents[i].selectable) {
                        this.agents[i].checked = true;
                    }
                }
            }

        },
        save_and_continue() {
            if (this.num_selected > 0) {
                this.skipped = false
                const url = `${this.$page.props.api_url}/v1/integration/${this.integration.id}/invite`;
                axios.post(url, {
                    integration_id: this.integration.id,
                    agents: this.agents
                }).then(response => {
                    if (this.integration.name == 'intercom') {
                        window.location.href = this.intercom_success;
                        return;
                    }
                    this.step = 2;
                }).catch(error => {
                    console.error('Error inviting agents:', error);
                    let options = {
                        type: "danger",
                        timeout: -1,
                        position: "top-right",
                    }
                    this.$moshaToast("An error occurred while inviting agents", options)
                })
                return;
            }
            if (this.integration.name == 'intercom') {
                window.location.href = this.intercom_success;
                return;
            }
            this.skipped = true
            this.step = 2
        },
        skip() {
            if (this.integration.name == 'intercom') {
                window.location.href = this.intercom_success;
                return;
            }
            this.skipped = true
            this.step = 2
        }
    },
    watch: {
        step(newStep, oldStep) {
            this.transitionName = newStep > oldStep ? 'slide-left' : 'slide-right';
            this.prevStep = newStep;
        }
    }
}
</script>


<style scoped>

/* Leftward slide (forward) */
.slide-left-enter-active,
.slide-left-leave-active {
    transition: all 0.3s ease;
}

.slide-left-enter-from {
    opacity: 0;
    transform: translateX(100%);
}

.slide-left-enter-to {
    opacity: 1;
    transform: translateX(0);
}

.slide-left-leave-from {
    opacity: 1;
    transform: translateX(0);
}

.slide-left-leave-to {
    opacity: 0;
    transform: translateX(-100%);
}

/* Rightward slide (backward) */
.slide-right-enter-active,
.slide-right-leave-active {
    transition: all 0.3s ease;
}

.slide-right-enter-from {
    opacity: 0;
    transform: translateX(-100%);
}

.slide-right-enter-to {
    opacity: 1;
    transform: translateX(0);
}

.slide-right-leave-from {
    opacity: 1;
    transform: translateX(0);
}

.slide-right-leave-to {
    opacity: 0;
    transform: translateX(100%);
}
</style>